import { shape, string } from 'prop-types';
import { RouteLink } from 'routes';
import { APP_CAN_APPS_V3 } from 'constants/appNames';
import { ListItemButton, ListItemText } from 'components/mui';
import styles from '../styles/cantab.module.css';
import { getCanTabState, setCanTabState } from '../libs/useLocalStorage';

/**
 * @component ListSubmenuTabs
 * @param { Object } props
 * @param { object } props.subtab
 * @returns { JSX.Element }
 */
function ListSubmenuTabs({ subtab, setMenuClose, activeTab }) {
	const onClickTab = () => {
		const canTabSettings = getCanTabState();
		canTabSettings.menuState = 'closed';
		setCanTabState(canTabSettings);
	};
	return subtab.type === APP_CAN_APPS_V3 ? (
		<ListItemButton
			className={`${styles.lsmt_list_btn} ${
				activeTab === `/${APP_CAN_APPS_V3}${subtab.url}` ? styles.active_tab : ''
			}`}
			component={RouteLink}
			to={subtab.url}
			onClick={() => {
				onClickTab();
				setMenuClose();
			}}
		>
			<ListItemText className={styles.lsmt_list_text} primary={subtab.name} />
		</ListItemButton>
	) : (
		<ListItemButton
			className={styles.lsmt_list_btn}
			component="a"
			href={subtab.url}
			onClick={onClickTab}
		>
			<ListItemText className={styles.lsmt_list_text} primary={subtab.name} />
		</ListItemButton>
	);
}

ListSubmenuTabs.propTypes = {
	subtab: shape({ id: string, name: string, url: string, type: string }),
};

export default ListSubmenuTabs;
